import { Locale } from '@core/Entities/Locale/Locale.entity';
import memoize from 'lodash.memoize';
import hash from 'stable-hash';

import { Calculation } from '../../../Entities/Calculation.entity';

import { env } from 'next-runtime-env';

const controller = new AbortController();
interface ValueContainer {
  value?: number;
}

type FetchCalculationProps = {
  vehicleId: string;
  locale: Locale;
  selectedProductId: string | undefined;
  deposit: number;
  terms: ValueContainer;
  mileage: ValueContainer;
  defaultDeposit?: number;
  defaultMonths?: number;
  defaultMileage?: number;
  vehiclePrice: number;
  additionalServices: any;
  isEmpty?: boolean;
  source?: string;
};
export const fetchCalculation = async (props: FetchCalculationProps) => {
  const {
    locale,
    selectedProductId,
    deposit,
    terms,
    mileage,
    defaultDeposit,
    defaultMonths,
    defaultMileage,
    vehiclePrice,
    additionalServices,
    vehicleId,
    isEmpty,
    source,
  } = props;

  return cachedFetchCalculation(
    hash(props),
    vehicleId,
    locale,
    selectedProductId,
    deposit ?? defaultDeposit ?? Math.round(vehiclePrice / 6.6666),
    terms?.value ?? defaultMonths ?? 36,
    mileage?.value ?? defaultMileage ?? 10000,
    additionalServices,
    isEmpty,
    source,
  );
};

type CachedFetchCalculation = (
  hash: string,
  vehicleId: string,
  tenant: Locale,
  productId: string | undefined,
  deposit: number,
  terms: number,
  mileage: number,
  additionalServices: any,
  isEmpty?: boolean,
  source?: string,
) => Promise<Calculation>;

export const cachedFetchCalculation: CachedFetchCalculation = memoize((async (...props) => {
  const [
    _hash,
    vehicleId,
    tenant,
    productId,
    deposit = 0,
    terms,
    mileage,
    additionalServices,
    isEmpty,
    source,
  ] = props;
  if (!vehicleId || !tenant || !terms) return undefined;

  const services =
    additionalServices &&
    Object.keys(additionalServices).reduce((acc, key) => {
      // eslint-disable-next-line no-param-reassign
      acc = {
        ...acc,
        [key]: additionalServices[key] ? '1' : '0',
      };
      return acc;
    }, {});

  try {
    const res = await fetch(
      `${env('NEXT_PUBLIC_COMMON_API_URL')}/i15-financing/${vehicleId}/calculation`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-heycar-tenant': tenant,
          source: source ?? 'heycar',
        },
        body: JSON.stringify({
          deposit: isEmpty ? undefined : deposit,
          months: isEmpty ? undefined : terms,
          mileage: isEmpty ? undefined : mileage,
          additionalServices: services || undefined,
          ...(productId && { selectedProduct: { [productId]: true } }),
        }),
        signal: controller.signal,
      },
    );

    const data = await res.json();

    return data as Calculation;
  } catch (error) {
    console.error('[CALC ERROR]', error);
    return null;
  }
}) as CachedFetchCalculation) as CachedFetchCalculation;
